import React from "react";
import InputGroup from "../../../../../components/form/InputGroup";
import { usePermitRequestContext } from "../../../../../contexts/PermitRequestContext";
import { useProjectConfigContext } from "../../../../../contexts/ProjectConfigContext";
import SectionTitle from "../../SectionTitle";
import RentingApartmentFiles from "./RentingApartmentFiles";
import HasBusinessFiles from "./HasBusinessFiles";
import FormSection from "../FormSection";
import { useTags } from "../../../../../hooks/useTags";
import addRequestPageLang from "../../../../../data/lang/add-request-page.lang";

function ExtraFileFormSection() {

    const { projectConfigState } = useProjectConfigContext();
    const { handleChange, Formik } = usePermitRequestContext();

    const { errors, touched, handleBlur } = Formik;

    const extraFilesConfig = projectConfigState.addRequestPageConfig.extraFiles;

    const hasBusinessFiles = extraFilesConfig.hasBusinessFiles;
    const rentingApartmentFiles = extraFilesConfig.hasRentingApartmentFiles;
    const hasExtraFile = extraFilesConfig.hasExtraFile;

    let hasAnyExtraFiles = (hasBusinessFiles || rentingApartmentFiles || hasExtraFile);

    const generateTag = useTags();

    const sectionTitle = generateTag(addRequestPageLang, 'form.files-section.title');
    const additionalFileLabel = generateTag(addRequestPageLang, 'form.files-section.additionalFileLabel');

    if (!hasAnyExtraFiles) return null;

    return (
        <FormSection>
            <SectionTitle title={sectionTitle} />

            {hasExtraFile ? (
                <div className="row">
                    <div className='col-sm-4'>
                        <InputGroup
                            type={'file'}
                            name={'extra1'}
                            label={additionalFileLabel}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            errorMsg={(errors['extra1'] && touched['extra1']) ? errors['extra1'] : undefined}
                        />
                    </div>
                </div>
            ) : ''}

            {rentingApartmentFiles ? <RentingApartmentFiles /> : ''}
            {hasBusinessFiles ? <HasBusinessFiles /> : ''}
        </FormSection>
    );

}

export default ExtraFileFormSection;